module.exports = __webpack_public_path__ + "img/grass-tile-0012.4d7982ae.jpg";